import React, { useState } from "react";
import "./Footer.css";

/* ================= SVG ICONS ================= */

const FacebookIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 1.8h8.5a3.95 3.95 0 0 1 3.95 3.95v8.5a3.95 3.95 0 0 1-3.95 3.95h-8.5a3.95 3.95 0 0 1-3.95-3.95v-8.5A3.95 3.95 0 0 1 7.75 3.8zm8.95 1.35a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 1.8A3.2 3.2 0 1 1 8.8 12 3.2 3.2 0 0 1 12 8.8z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.55 9.376.55 9.376.55s7.505 0 9.377-.55a3.016 3.016 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.75 15.5v-7l6 3.5-6 3.5z" />
  </svg>
);

function Footer() {
  const [openQR, setOpenQR] = useState(false);

  return (
    <>
      <footer className="premium-blue-footer">
        <div className="footer-grid-overlay"></div>

        <div className="footer-main-container">
          <div className="footer-columns-grid">

            {/* BRAND */}
            <div className="footer-col brand-col">
              <h2 className="footer-brand-title">Anuk Charitable Trust & Old Age Home</h2>

              <p className="footer-brand-desc">
                Anuk Charitable Trust is dedicated to transforming lives through
                consistent grassroots empowerment. We bridge systemic gaps by
                providing continuous care, educational opportunities, and vital
                relief to marginalized communities.
              </p>

              {/* SOCIAL ICONS */}
              <div className="social-icons-strip">

                {/* FACEBOOK */}
                <a
                  href="https://www.facebook.com/profile.php?id=61578757086828"
                  target="_blank"
                  rel="noreferrer"
                  className="social-circle"
                  aria-label="Facebook"
                >
                  <FacebookIcon />
                </a>

                {/* INSTAGRAM */}
                <a
                  href="https://www.instagram.com/anuk_charity3773?igsh=MXFyZ3FnOWN3dnN6aQ=="
                  target="_blank"
                  rel="noreferrer"
                  className="social-circle"
                  aria-label="Instagram"
                >
                  <InstagramIcon />
                </a>

                {/* YOUTUBE */}
                <a
                  href="https://youtube.com/@suriyadelfine7513?si=QINupcdRlESp1skf"
                  target="_blank"
                  rel="noreferrer"
                  className="social-circle"
                  aria-label="YouTube"
                >
                  <YouTubeIcon />
                </a>

              </div>
            </div>

            {/* QUICK LINKS */}
            <div className="footer-col list-col">
              <h3 className="footer-col-heading">Quick Links</h3>

              <ul className="footer-link-list">
                <li><a href="/">Home</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/programs">Programs</a></li>
                <li><a href="/volunteer">Volunteer</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

            {/* PROGRAMS */}
            <div className="footer-col list-col">
              <h3 className="footer-col-heading">Our Programs</h3>

              <ul className="footer-link-list">
                <li><a href="/programs">Education Support</a></li>
                <li><a href="/programs">Healthcare Services</a></li>
                <li><a href="/programs">Women Empowerment</a></li>
                <li><a href="/programs">Child Welfare</a></li>
              </ul>
            </div>

            {/* CONTACT */}
            <div className="footer-col contact-col">
              <h3 className="footer-col-heading">Get in Touch</h3>

              <div className="contact-details-box">

                <div className="detail-row">
                  <span className="detail-label">Address:</span>
                  <p>
                    No. 14/60, 8th Cross, Brindhavanam,
                    Puducherry – 605013
                  </p>
                </div>

                <div className="detail-row">
                  <span className="detail-label">Mobile:</span>

                  <p>
                    <a href="tel:+918668106574">
                      +91 94457 24840 | +91 86681 06574
                    </a>
                  </p>
                </div>

                <div className="detail-row">
                  <span className="detail-label">Email:</span>

                  <p>
                    <a href="mailto:anukdonor@anukcharity.org">
                      support@anukcharitabletrust.com
                    </a>
                  </p>
                </div>

              </div>
            </div>

            {/* BANKING */}
            <div className="footer-col banking-col">

              <h3 className="footer-col-heading">
                Instant Transfer
              </h3>

              <div className="banking-transfer-card">

                <div className="bank-meta">

                  <span className="b-name">
                    Anuk Charitable Trust
                  </span>

                  <span className="b-acc">
                    A/c No: <strong>76720200002280</strong>
                  </span>

                  <span className="b-ifsc">
                    IFSC Code: <strong>BARB0VJPOND</strong>
                  </span>

                  <span
                    className="b-branch"
                    style={{ fontSize: "12px" }}
                  >
                    Pondicherry Branch
                  </span>

                </div>

                {/* QR SECTION */}
                <div className="qr-visual-block">

                  <div
                    className="qr-thumb clickable-qr"
                    onClick={() => setOpenQR(true)}
                  >
                    <img
                      src="images/qr-code.png"
                      alt="QR Code"
                      className="qr-image"
                    />
                  </div>

                  <div className="qr-labels">
                    <span className="lbl-top">
                      Scan to Donate
                    </span>

                    <span className="lbl-upi">
                      Anuk Charitable Trust
                    </span>
                  </div>

                </div>

              </div>
            </div>

          </div>

          {/* COPYRIGHT */}
          <div className="footer-rounded-bottom-strip">

            <div className="strip-content-flex">

              <p className="copyright-line">
                Copyright © {new Date().getFullYear()}
                {" "}Anuk Charitable Trust.
                All Rights Reserved.
              </p>

              <ul className="legal-links-list">
                <li>
                  <a href="/PrivacyPolicy">
                    Privacy Policy
                  </a>
                </li>

                <li>
                  <a href="/TermsOfService">
                    Terms of Service
                  </a>
                </li>

                <li>
                  <a href="/ReportIssue">
                    Report an Issue
                  </a>
                </li>
              </ul>

            </div>

          </div>

        </div>
      </footer>

      {/* FULLSCREEN QR MODAL */}
      {openQR && (
        <div
          className="qr-fullscreen-overlay"
          onClick={() => setOpenQR(false)}
        >

          <div
            className="qr-fullscreen-card"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="qr-close-btn"
              onClick={() => setOpenQR(false)}
            >
              ×
            </button>

            <div className="qr-modal-header">
              <h2>Scan to Donate</h2>
              <p>Anuk Charitable Trust</p>
            </div>

            <div className="qr-full-image-wrapper">
              <img
                src="images/qr-code.png"
                alt="Full QR"
                className="qr-full-image"
              />
            </div>

            <div className="qr-bank-details">

              <h4>Anuk Charitable Trust</h4>

              <p>
                A/c No: <strong>76720200002280</strong>
              </p>

              <p>
                IFSC: <strong>BARB0VJPOND</strong>
              </p>

              <span>Pondicherry Branch</span>

            </div>

          </div>

        </div>
      )}
    </>
  );
}

export default Footer;